/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Data object that contains information necessary to apply user registration
 * @export
 * @interface OrgUserRegistrationData
 */
export interface OrgUserRegistrationData {
    /**
     * Code of the user's title
     * @type {string}
     * @memberof OrgUserRegistrationData
     */
    titleCode?: string;
    /**
     * First name of the user
     * @type {string}
     * @memberof OrgUserRegistrationData
     */
    firstName: string;
    /**
     * Last name of the user
     * @type {string}
     * @memberof OrgUserRegistrationData
     */
    lastName: string;
    /**
     * Email of the user
     * @type {string}
     * @memberof OrgUserRegistrationData
     */
    email: string;
    /**
     * Contains info to approver, usually composed by UI with a template
     * @type {string}
     * @memberof OrgUserRegistrationData
     */
    message?: string;
    /**
     * Authentication identifier of a new B2B customer registration. Only needed when OTP for registration is enabled.
     * @type {string}
     * @memberof OrgUserRegistrationData
     */
    verificationTokenId?: string;
    /**
     * Code included in the email sent to the customer to be registered. Only needed when OTP for registration is enabled.
     * @type {string}
     * @memberof OrgUserRegistrationData
     */
    verificationTokenCode?: string;
}

/**
 * Check if a given object implements the OrgUserRegistrationData interface.
 */
export function instanceOfOrgUserRegistrationData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "firstName" in value;
    isInstance = isInstance && "lastName" in value;
    isInstance = isInstance && "email" in value;

    return isInstance;
}

export function OrgUserRegistrationDataFromJSON(json: any): OrgUserRegistrationData {
    return OrgUserRegistrationDataFromJSONTyped(json, false);
}

export function OrgUserRegistrationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrgUserRegistrationData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'titleCode': !exists(json, 'titleCode') ? undefined : json['titleCode'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'email': json['email'],
        'message': !exists(json, 'message') ? undefined : json['message'],
        'verificationTokenId': !exists(json, 'verificationTokenId') ? undefined : json['verificationTokenId'],
        'verificationTokenCode': !exists(json, 'verificationTokenCode') ? undefined : json['verificationTokenCode'],
    };
}

export function OrgUserRegistrationDataToJSON(value?: OrgUserRegistrationData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'titleCode': value.titleCode,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'email': value.email,
        'message': value.message,
        'verificationTokenId': value.verificationTokenId,
        'verificationTokenCode': value.verificationTokenCode,
    };
}

